"use client";

import { handleLogout, useAuth } from "@/app/firebase/auth";
import React from "react";
import { Navigation } from "@anu-its/ts-react-components";

export default function NavBar() {
  const { user } = useAuth();

  function forceLogout() {
    handleLogout();
  }

  const userDetails = {
    name: user?.displayName || "",
    displayName: user?.displayName || "",
    email: user?.email || "",
    handleLogout: forceLogout,
  };

  return (
    <Navigation
      {...(user && { user: userDetails })}
      menuItems={[
        {
          href: "/",
          label: "Dashboard",
          id: "dashboard",
        },
      ]}
    />
  );
}
